import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { changePassword, getToken } from './api';
import { input, label } from './adminUi';

export default function ChangePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg('');
    setErr('');
    if (newPassword !== confirm) {
      setErr('New password and confirmation do not match.');
      return;
    }
    if (!getToken()) {
      navigate('/admin', { replace: true });
      return;
    }
    setSaving(true);
    try {
      await changePassword(currentPassword, newPassword);
      setCurrentPassword('');
      setNewPassword('');
      setConfirm('');
      setMsg('Password updated. Use the new password next time you sign in.');
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Update failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto p-4 md:p-6">
      <div className="w-full">
        <p className="text-xs font-medium text-neutral-500">Account</p>
        <h2 className="text-lg font-bold text-neutral-900">Change password</h2>
        <p className="mt-1 text-sm text-neutral-600">
          Enter your current password, then choose a new one (at least 8 characters).
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className={label} htmlFor="cp-current">
              Current password
            </label>
            <input
              id="cp-current"
              type="password"
              className={input}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <div>
            <label className={label} htmlFor="cp-new">
              New password
            </label>
            <input
              id="cp-new"
              type="password"
              className={input}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className={label} htmlFor="cp-confirm">
              Confirm new password
            </label>
            <input
              id="cp-confirm"
              type="password"
              className={input}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <button
            type="submit"
            disabled={saving}
            className="w-full rounded-lg bg-brand-olive px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-50"
          >
            {saving ? 'Saving…' : 'Update password'}
          </button>
        </form>

        {msg ? <p className="mt-4 text-sm text-green-700">{msg}</p> : null}
        {err ? <p className="mt-4 text-sm text-red-600">{err}</p> : null}
      </div>
    </div>
  );
}
